module.exports = __webpack_public_path__ + "static/azuth-DND3_FnP-cce9ad8ee5bea0afc29ed997d2a88aca.webp";